import { render } from "./FontSizeLacen.vue?vue&type=template&id=5abe1524&scoped=true"
import script from "./FontSizeLacen.vue?vue&type=script&lang=js"
export * from "./FontSizeLacen.vue?vue&type=script&lang=js"

import "./FontSizeLacen.vue?vue&type=style&index=0&id=5abe1524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abe1524"]])

export default __exports__